document.addEventListener('DOMContentLoaded', function() {
    
    const scripts = [
        '/assets/components/video/vendor/videojs/video.min.js',
    ];
    const styles = [
        '/assets/components/video/vendor/videojs/style.css',
    ];
    
    window.ABVideo = {
        loadAssets: function() {
            if (!('videojs' in window)) {
                const checkScripts = function() {
                    let cnt = 0;
                    scripts.forEach(scriptLink => {
                        if (document.querySelector(`script[src="${scriptLink}"]`))
                            cnt++;
                    });
                    return cnt === scripts.length;
                };
                
                const checkStyles = function() {
                    let cnt = 0;
                    styles.forEach(styleLink => {
                        if (document.querySelector(`link[href="${styleLink}"]`))
                            cnt++;
                    });
                    return cnt === styles.length;
                }
                
                const checkAll = function() {
                    return checkScripts() && checkStyles();
                };
                
                const onLoad = function() {
                    if (!window.ABVideo.isAssetsLoaded && checkAll()) {
                        window.ABVideo.isAssetsLoaded = true;
                        
                        setTimeout(function() {
                            document.dispatchEvent (
                                new CustomEvent ('ab.video.assets.ready', {
                                    bubbles: true,
                                    cancelable: true,
                                }));
                        }, 200);
                    }
                };
                
                scripts.forEach(scriptLink => {
                    globalFunctions.loadScript(scriptLink)
                        .then(data => {
                            if (checkScripts()) {
                                onLoad();
                            }
                        })
                        .catch((err, data) => {
                            // TODO
                            // onError(err, data);
                        });
                });
                
                styles.forEach(styleLink => {
                    let link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = styleLink;
                    document.getElementsByTagName('head')[0].appendChild(link);
                    
                    const loadInterval = setInterval(function() {
                        if (document.head.querySelector(`link[href="${styleLink}"]`)) {
                            clearInterval(loadInterval);
                            
                            if (checkStyles()) {
                                onLoad();
                            }
                        }
                    }, 100);
                });
                
                return false;
                
            } else {
                return true;
            }    
        },
        
        initVideoPlayer: function(element) {
            element.classList.add('video-js');
            videojs(element, {
                controls: true,
                fluid: true,
            });
        },
        
        init: function(element) {
            const isLoaded = this.loadAssets();
            
            if (isLoaded) {
                this.initVideoPlayer(element);
                
            } else {
                document.addEventListener('ab.video.assets.ready', () => {
                    this.initVideoPlayer(element);
                });
            }
        }
    };
    
    document.querySelectorAll('.js-videoplayer:not([data-init="false"])').forEach(element => {
        ABVideo.init(element);
    });
});
